__turbopack_context__.v({
  "chevronMobile": "LangSelector-module-scss-module__sTS7gq__chevronMobile",
  "chevronMobileOpen": "LangSelector-module-scss-module__sTS7gq__chevronMobileOpen",
  "code": "LangSelector-module-scss-module__sTS7gq__code",
  "dropdownItem": "LangSelector-module-scss-module__sTS7gq__dropdownItem",
  "dropdownMenu": "LangSelector-module-scss-module__sTS7gq__dropdownMenu",
  "fadeInOpacity": "LangSelector-module-scss-module__sTS7gq__fadeInOpacity",
  "flag": "LangSelector-module-scss-module__sTS7gq__flag",
  "flagMobileBlock": "LangSelector-module-scss-module__sTS7gq__flagMobileBlock",
  "mobileBlockList": "LangSelector-module-scss-module__sTS7gq__mobileBlockList",
  "mobileBlockListMotion": "LangSelector-module-scss-module__sTS7gq__mobileBlockListMotion",
  "mobileBlockOption": "LangSelector-module-scss-module__sTS7gq__mobileBlockOption",
  "mobileBlockScroll": "LangSelector-module-scss-module__sTS7gq__mobileBlockScroll",
  "name": "LangSelector-module-scss-module__sTS7gq__name",
  "selectorButton": "LangSelector-module-scss-module__sTS7gq__selectorButton",
  "selectorContent": "LangSelector-module-scss-module__sTS7gq__selectorContent",
  "triggerCode": "LangSelector-module-scss-module__sTS7gq__triggerCode",
  "triggerLabel": "LangSelector-module-scss-module__sTS7gq__triggerLabel",
  "triggerMobileBlock": "LangSelector-module-scss-module__sTS7gq__triggerMobileBlock",
  "wrapper": "LangSelector-module-scss-module__sTS7gq__wrapper",
  "wrapperMobileBlock": "LangSelector-module-scss-module__sTS7gq__wrapperMobileBlock",
});
